import React from 'react';
export function Terms26() {
  return <div className="pt-20" data-id="element-1881">
      {/* Hero */}
      <section className="pt-10 pb-6 md:pt-16 md:pb-8 bg-gradient-to-br from-gray-50 to-white" data-id="element-1882">
        <div className="container-custom" data-id="element-1883">
          <div className="max-w-4xl mx-auto text-center" data-id="element-1884">
            <h1 className="mb-4" data-id="element-1885">HIRE Advantage Agreement</h1>
            <p className="text-body-large text-gray-600" data-id="element-1886">
              Terms and Conditions of Service
            </p>
          </div>
        </div>
      </section>

      {/* Agreement Content */}
      <section className="py-8 md:py-12 bg-white" data-id="element-1887">
        <div className="container-custom" data-id="element-1888">
          <div className="max-w-4xl mx-auto prose prose-lg" data-id="element-1889">
            {/* Preamble */}
            <div className="mb-12 bg-gray-50 rounded-lg p-6 border-l-4 border-mint" data-id="element-1890">
              <p className="leading-relaxed" data-id="element-1891">
                This HIRE Advantage Agreement (together with all applicable
                Services Order(s) and addenda, executed hereunder, the
                "Agreement") is entered into by and between the HIRE entity
                identified in a Service Order ("HIRE") and the counterparty to
                that Service Order ("Client") and contains the terms and
                conditions that govern Client's access to and use of the Scope
                of Services (see defined below). This agreement is effective
                when Client executes a Services Order referencing this Agreement
                (the "Effective Date").
              </p>
            </div>

            {/* 1. Introduction & Recitals */}
            <div className="mb-12" data-id="element-1892">
              <h2 className="text-2xl font-bold text-deep-blue mb-4" data-id="element-1893">
                1. Introduction & Recitals
              </h2>
              <p className="leading-relaxed" data-id="element-1894">
                HIRE provides high-performance recruiting solutions designed to
                scale businesses. Under this Agreement, HIRE will deliver its
                Proprietary Recruiting System, which combines advanced
                recruiting services with consulting, coaching, and ongoing
                support to optimize candidate experience, onboarding, and
                retention.
              </p>
            </div>

            {/* 2. Definitions */}
            <div className="mb-12" data-id="element-1895">
              <h2 className="text-2xl font-bold text-deep-blue mb-4" data-id="element-1896">
                2. Definitions
              </h2>

              <div className="space-y-4" data-id="element-1897">
                <p className="leading-relaxed" data-id="element-1898">
                  <strong className="text-deep-blue" data-id="element-1899">Ad Spend:</strong> The
                  amount invested by the Client for advertising campaigns, paid
                  to a third-party.
                </p>

                <p className="leading-relaxed" data-id="element-1900">
                  <strong className="text-deep-blue" data-id="element-1901">Campaign:</strong> A set of
                  1–10 marketing ads used within a geographic region.
                </p>

                <p className="leading-relaxed" data-id="element-1902">
                  <strong className="text-deep-blue" data-id="element-1903">Campaign Launch:</strong>{' '}
                  The first business day following the date when the applicant
                  tracking system is live (system of record for Client to track
                  Recruits) and targeted ad campaigns are posted.
                </p>

                <p className="leading-relaxed" data-id="element-1904">
                  <strong className="text-deep-blue" data-id="element-1905">
                    Corporate Recruiter:
                  </strong>{' '}
                  The HIRE-provided recruiter assigned to manage and support a
                  Client's active campaigns. Also referred to as "Recruiter" in
                  prior Service Orders.
                </p>

                <p className="leading-relaxed" data-id="element-1906">
                  <strong className="text-deep-blue" data-id="element-1907">Placement:</strong> A
                  Recruit who has successfully completed and graduated from
                  HIRE's two-day sales school, or, if the Client has opted out
                  of HIRE's sales school, a Recruit who has begun the Client's
                  training program or entered the field.
                </p>

                <p className="leading-relaxed" data-id="element-1908">
                  <strong className="text-deep-blue" data-id="element-1909">Placement Date:</strong>{' '}
                  The date on which the Recruit successfully completes and
                  graduates from HIRE's two-day sales school, or, if the Client
                  has opted out of HIRE's sales school, the first day the
                  Recruit begins the Client's training program or enters the
                  field, whichever occurs first. This date triggers the
                  Placement Fee.
                </p>

                <p className="leading-relaxed" data-id="element-1910">
                  <strong className="text-deep-blue" data-id="element-1911">
                    Proprietary Recruiting System:
                  </strong>{' '}
                  HIRE's exclusive methods, processes, training materials, and
                  technology used by HIRE.
                </p>

                <p className="leading-relaxed" data-id="element-1912">
                  <strong className="text-deep-blue" data-id="element-1913">Recruit:</strong> A
                  candidate who is sourced by HIRE Campaigns.
                </p>

                <p className="leading-relaxed" data-id="element-1914">
                  <strong className="text-deep-blue" data-id="element-1915">
                    Sales School Start Date:
                  </strong>{' '}
                  The Monday on which the Recruit begins attendance at HIRE's
                  two-day sales school. If the Client has opted out of HIRE's
                  sales school, the Sales School Start Date shall be deemed the
                  first day the Recruit begins the Client's training program or
                  enters the field, whichever occurs first. This date serves as
                  the anchor for calculating the Retention Fee commencement
                  date.
                </p>

                <p className="leading-relaxed" data-id="element-1916">
                  <strong className="text-deep-blue" data-id="element-1917">Services:</strong> Services
                  listed in section 3.
                </p>

                <p className="leading-relaxed" data-id="element-1918">
                  <strong className="text-deep-blue" data-id="element-1919">Services Order:</strong>{' '}
                  The document by which Client orders, and HIRE agrees to
                  provide, Services Pursuant to this Agreement.
                </p>
              </div>
            </div>

            {/* 3. Scope of Services */}
            <div className="mb-12" data-id="element-1920">
              <h2 className="text-2xl font-bold text-deep-blue mb-4" data-id="element-1921">
                3. Scope of Services
              </h2>
              <p className="leading-relaxed mb-6" data-id="element-1922">
                As part of this Agreement, HIRE shall provide the following
                services, aligned to the fee categories in Section 4:
              </p>

              <div className="space-y-6" data-id="element-1923">
                <div data-id="element-1924">
                  <h3 className="text-xl font-semibold text-deep-blue mb-3" data-id="element-1925">
                    Build
                  </h3>
                  <ul className="list-disc ml-6 space-y-2" data-id="element-1926">
                    <li data-id="element-1927">Custom Recruiting System Buildout</li>
                    <li data-id="element-1928">ATS Integration & Tracking</li>
                    <li data-id="element-1929">Initial Setup of Automated Applicant Communication</li>
                    <li data-id="element-1930">
                      Initial Configuration of Live Data & Dashboard Access
                    </li>
                  </ul>
                </div>

                <div data-id="element-1931">
                  <h3 className="text-xl font-semibold text-deep-blue mb-3" data-id="element-1932">
                    Platform
                  </h3>
                  <ul className="list-disc ml-6 space-y-2" data-id="element-1933">
                    <li data-id="element-1934">
                      Access to HIRE's proprietary recruiting platform,
                      integrations, dashboards, and reporting tools
                    </li>
                    <li data-id="element-1935">Ongoing Ad Performance Analysis & Adjustments</li>
                    <li data-id="element-1936">Monthly Executive Recruiting Review</li>
                    <li data-id="element-1937">
                      Ongoing Recruiting Best Practice Training (including
                      webinars)
                    </li>
                    <li data-id="element-1938">
                      Hiring Manager Support (1:1 training, auditing, coaching)
                    </li>
                    <li data-id="element-1939">Performance Benchmarking</li>
                  </ul>
                </div>

                <div data-id="element-1940">
                  <h3 className="text-xl font-semibold text-deep-blue mb-3" data-id="element-1941">
                    Campaign
                  </h3>
                  <ul className="list-disc ml-6 space-y-2" data-id="element-1942">
                    <li data-id="element-1943">
                      Targeted Ad Campaigns (copywriting, branding, posting job
                      listings)
                    </li>
                    <li data-id="element-1944">Pre-Screening & Pre-Qualification</li>
                    <li data-id="element-1945">Done-for-You Screening Calls</li>
                    <li data-id="element-1946">
                      Pre-Qualified Interviews Booked into Client's Calendar
                    </li>
                  </ul>
                </div>

                <div data-id="element-1947">
                  <h3 className="text-xl font-semibold text-deep-blue mb-3" data-id="element-1948">
                    Corporate Recruiter
                  </h3>
                  <p className="leading-relaxed mb-3" data-id="element-1949">
                    When the Corporate Recruiter service is selected, HIRE
                    replaces the Client's in-house recruiter function. Under
                    this service:
                  </p>
                  <ul className="list-disc ml-6 space-y-2" data-id="element-1950">
                    <li data-id="element-1951">
                      HIRE provides a corporate recruiter aligned with the
                      Client's campaigns.
                    </li>
                    <li data-id="element-1952">
                      The Client no longer conducts hiring meetings with a
                      hiring manager or recruiter.
                    </li>
                    <li data-id="element-1953">
                      Instead, the Client accepts or rejects candidates provided
                      by HIRE prior to the candidate attending Sales School or,
                      if the Client has opted out of HIRE's sales school, prior
                      to the candidate beginning the Client's training program
                      or entering the field.
                    </li>
                  </ul>
                </div>

                <div data-id="element-1954">
                  <h3 className="text-xl font-semibold text-deep-blue mb-3" data-id="element-1955">
                    Placement
                  </h3>
                  <ul className="list-disc ml-6 space-y-2" data-id="element-1956">
                    <li data-id="element-1957">Candidate Experience Optimization</li>
                    <li data-id="element-1958">Onboarding System Buildout</li>
                    <li data-id="element-1959">Early Retention Strategy Development</li>
                    <li data-id="element-1960">
                      Virtual Sales Schools and related training/consulting to
                      support candidate readiness and retention
                    </li>
                  </ul>
                  <p className="leading-relaxed mt-3" data-id="element-1961">
                    Participation in HIRE's virtual sales school is optional.
                    Clients who opt out remain subject to all Placement and
                    Retention Fee obligations as defined in Section 4.1.
                  </p>
                </div>
              </div>

              <div className="mt-6 bg-gray-50 rounded-lg p-6 border-l-4 border-mint" data-id="element-1962">
                <p className="leading-relaxed" data-id="element-1963">
                  <strong className="text-deep-blue" data-id="element-1964">
                    General Terms of Service Delivery:
                  </strong>{' '}
                  Services are delivered in a commercially reasonable manner and
                  may be adjusted by HIRE to reflect evolving best practices.
                  Certain services, such as virtual sales schools, may be
                  subject to schedule availability.
                </p>
              </div>
            </div>

            {/* 4. Payment Terms */}
            <div className="mb-12" data-id="element-1965">
              <h2 className="text-2xl font-bold text-deep-blue mb-4" data-id="element-1966">
                4. Payment Terms
              </h2>

              <h3 className="text-xl font-semibold text-deep-blue mb-3" data-id="element-1967">
                4.1 Product Fees
              </h3>
              <p className="leading-relaxed mb-4" data-id="element-1968">
                Client agrees to pay the following Product Fees in accordance
                with the amounts and rates set forth in the applicable Services
                Order:
              </p>
              <div className="space-y-4 mb-6" data-id="element-1969">
                <p className="leading-relaxed" data-id="element-1970">
                  <strong className="text-deep-blue" data-id="element-1971">Build (One-Time):</strong>{' '}
                  A one-time setup fee, invoiced and due upon execution of the
                  Services Order.
                </p>

                <p className="leading-relaxed" data-id="element-1972">
                  <strong className="text-deep-blue" data-id="element-1973">
                    Platform (Recurring Monthly):
                  </strong>{' '}
                  A recurring monthly fee that provides ongoing access to HIRE's
                  proprietary recruiting platform, integrations, dashboards,
                  reporting tools, and related support services.
                </p>

                <p className="leading-relaxed" data-id="element-1974">
                  <strong className="text-deep-blue" data-id="element-1975">
                    Corporate Recruiter (Recurring Monthly):
                  </strong>{' '}
                  A recurring monthly fee per Corporate Recruiter provided by
                  HIRE. Corporate Recruiter quantity must equal the number of
                  active campaigns under management.
                </p>

                <p className="leading-relaxed" data-id="element-1976">
                  <strong className="text-deep-blue" data-id="element-1977">
                    Campaign(s) (Recurring Monthly):
                  </strong>{' '}
                  A recurring monthly fee per campaign under management.
                </p>

                <div data-id="element-1978">
                  <p className="leading-relaxed mb-3" data-id="element-1979">
                    <strong className="text-deep-blue" data-id="element-1980">
                      Placement (Monthly, Billed in Arrears):
                    </strong>{' '}
                    The Placement fee structure consists of two components, both
                    invoiced at the start of each calendar month in arrears for
                    the prior calendar month:
                  </p>
                  <div className="ml-6 space-y-3" data-id="element-1981">
                    <p className="leading-relaxed" data-id="element-1982">
                      <strong data-id="element-1983">(a) Placement Fee:</strong> A monthly fee charged
                      per Recruit who has reached the Placement Date, as defined
                      in Section 2, during the prior calendar month.
                    </p>
                    <p className="leading-relaxed" data-id="element-1984">
                      <strong data-id="element-1985">(b) Retention Fee:</strong> A recurring monthly
                      fee charged per hire, commencing on the one-month
                      anniversary of the Sales School Start Date and continuing
                      for up to twelve (12) months, unless a different maximum
                      is specified in the applicable Services Order. Invoices
                      will itemize this component as "Retention Fee."
                    </p>
                  </div>
                  <p className="leading-relaxed mt-3" data-id="element-1986">
                    Both components survive termination of this Agreement and
                    remain payable for all Placements delivered prior to
                    termination.
                  </p>
                </div>
              </div>

              <h3 className="text-xl font-semibold text-deep-blue mb-3" data-id="element-1987">
                4.2 Payment Schedule
              </h3>
              <p className="leading-relaxed mb-4" data-id="element-1988">
                All payments are due upon receipt, unless otherwise specified in
                the applicable Services Order.
              </p>

              <div className="space-y-4 mb-6" data-id="element-1989">
                <p className="leading-relaxed" data-id="element-1990">
                  <strong className="text-deep-blue" data-id="element-1991">Build Fee:</strong> The
                  one-time Build Fee is due upon execution of this Agreement and
                  before HIRE begins the campaign and account build.
                </p>

                <p className="leading-relaxed" data-id="element-1992">
                  <strong className="text-deep-blue" data-id="element-1993">
                    Subscription Invoice (Platform, Campaign, and Corporate
                    Recruiter Fees):
                  </strong>{' '}
                  The first Platform Fee, Campaign Fee(s), and Corporate
                  Recruiter Fee(s) are due upon Campaign Launch. Thereafter,
                  these fees are invoiced together on each monthly anniversary
                  of Campaign Launch and are due upon receipt.
                </p>

                <p className="leading-relaxed" data-id="element-1994">
                  <strong className="text-deep-blue" data-id="element-1995">
                    Placement & Retention Fee Invoice:
                  </strong>{' '}
                  Placement Fees and Retention Fees are invoiced together at the
                  start of each calendar month, in arrears for the prior
                  calendar month, in accordance with Section 4.1, and are due
                  upon receipt.
                </p>
              </div>

              <p className="leading-relaxed mb-6" data-id="element-1996">
                <strong className="text-deep-blue" data-id="element-1997">
                  Late Payment Penalties:
                </strong>{' '}
                A five-day grace period applies. After five days, unpaid amounts
                will incur a 5% monthly interest fee. Client agrees HIRE may
                suspend all services and withhold all deliverables immediately
                upon nonpayment, without liability, until account is current.
              </p>

              <p className="leading-relaxed mb-6" data-id="element-1998">
                Client hereby authorizes HIRE to automatically process all
                payments via ACH transfer or credit card on file. Payments made
                by credit card shall be subject to a processing surcharge of
                three percent (3%).
              </p>

              <h3 className="text-xl font-semibold text-deep-blue mb-3" data-id="element-1999">
                4.3 Campaign Scope & Expansion
              </h3>
              <div className="space-y-4 mb-6" data-id="element-2000">
                <p className="leading-relaxed" data-id="element-2001">
                  <strong className="text-deep-blue" data-id="element-2002">
                    Number of Contracted Campaigns:
                  </strong>{' '}
                  The Client and HIRE agree that this Agreement covers
                  campaign(s), with each campaign defined as up to ten (10)
                  managed ads in a particular geographic region.
                </p>

                <p className="leading-relaxed" data-id="element-2003">
                  <strong className="text-deep-blue" data-id="element-2004">
                    Additional Campaign Expansion:
                  </strong>{' '}
                  The Client may expand by adding campaigns beyond the initially
                  agreed number. Each additional campaign will be billed at the
                  rate on the service order, contingent on HIRE's capacity and
                  mutual agreement.
                </p>

                <p className="leading-relaxed" data-id="element-2005">
                  <strong className="text-deep-blue" data-id="element-2006">
                    Campaign Reduction:
                  </strong>{' '}
                  Campaigns may be reduced or paused on a monthly basis with
                  written notice, provided that each campaign operates on a
                  minimum thirty (30)-day cycle. Any reduction shall be prorated
                  and aligned with the Client's monthly billing cycle.
                </p>

                <div data-id="element-2007">
                  <p className="leading-relaxed" data-id="element-2008">
                    <strong className="text-deep-blue" data-id="element-2009">
                      Campaign Reallocations & Adjustments:
                    </strong>
                  </p>
                  <ul className="list-disc ml-6 space-y-2 mt-2" data-id="element-2010">
                    <li data-id="element-2011">
                      Ad spend may be reallocated across campaigns in real time,
                      based on performance and hiring needs.
                    </li>
                    <li data-id="element-2012">
                      If a campaign is removed and replaced with an entirely new
                      campaign, the Client must confirm with HIRE prior to
                      implementation.
                    </li>
                  </ul>
                </div>
              </div>

              <h3 className="text-xl font-semibold text-deep-blue mb-3" data-id="element-2013">
                4.4 Ad Spend Responsibility
              </h3>
              <p className="leading-relaxed" data-id="element-2014">
                The Client is solely responsible for all advertising costs ("Ad
                Spend") incurred in connection with campaigns under this
                Agreement. Ad Spend is billed directly by the applicable job
                boards or advertising platforms to the Client and is not
                included in HIRE's fees.
              </p>
            </div>

            {/* 5. Performance Commitment */}
            <div className="mb-12" data-id="element-2015">
              <h2 className="text-2xl font-bold text-deep-blue mb-4" data-id="element-2016">
                5. Performance Commitment
              </h2>
              <p className="leading-relaxed mb-4" data-id="element-2017">
                If, within the first 90 days of Campaign Launch AND the Client
                spends at least $12,500 in total advertising, HIRE guarantees at
                least twenty-five (25) Recruits who have been offered a position
                by or for the Client.
              </p>
              <p className="leading-relaxed mb-4" data-id="element-2018">
                If this condition is not met within 90 days, HIRE will continue
                providing campaign services at no additional Platform or
                Campaign Fee until the guarantee is fulfilled. The Client
                remains responsible for advertising costs and all Placement and
                Retention Fees for all Placements delivered during this period.
              </p>
              <p className="leading-relaxed" data-id="element-2019">
                This guarantee is contingent upon the Client's full adherence to
                HIRE's Proprietary Recruiting System as directed, including:
                attending all scheduled interviewing and coaching calls with
                HIRE; following HIRE's interview and onboarding process;
                responding to candidate submissions within one (1) business day;
                maintaining an active Zoom account and attending all HIRE
                coaching and interviewing calls via Zoom; maintaining sufficient
                calendar availability to schedule and conduct candidate
                interviews in a timely manner; and fulfilling all Client
                responsibilities under Section 6 of this Agreement. Failure to
                meet any of the above conditions voids this performance
                guarantee. This guarantee applies only while the Client's
                account is in good standing, meaning all Subscription Fees are
                current and paid in full throughout the 90-day guarantee period.
              </p>
            </div>

            {/* 6. Client Responsibilities */}
            <div className="mb-12" data-id="element-2020">
              <h2 className="text-2xl font-bold text-deep-blue mb-4" data-id="element-2021">
                6. Client Responsibilities
              </h2>
              <p className="leading-relaxed mb-4" data-id="element-2022">The Client shall:</p>
              <ul className="list-disc ml-6 space-y-2" data-id="element-2023">
                <li data-id="element-2024">
                  Have personnel to support interviews, hiring, and onboarding.
                </li>
                <li data-id="element-2025">
                  Allocate proper time for onboarding activities and ongoing
                  meetings.
                </li>
                <li data-id="element-2026">
                  Provide branding materials (logo, tagline, color scheme).
                </li>
                <li data-id="element-2027">Collaborate with HIRE on culture video production.</li>
                <li data-id="element-2028">Set up a dedicated company email for Indeed access.</li>
                <li data-id="element-2029">
                  Provide Google Calendar details for recruiters/screeners.
                </li>
                <li data-id="element-2030">Report sales statistics weekly for Recruits.</li>
                <li data-id="element-2031">
                  Provide necessary materials within seven (7) days of contract
                  execution.
                </li>
                <li data-id="element-2032">
                  Notify HIRE within one (1) business day of a Recruit beginning
                  the Client's training program or entering the field, in the
                  event the Client has opted out of HIRE's two-day sales school.
                  This notification serves as the basis for determining the
                  Placement Date and Sales School Start Date under this
                  Agreement.
                </li>
              </ul>
            </div>

            {/* 7. Confidentiality & Proprietary Rights */}
            <div className="mb-12" data-id="element-2033">
              <h2 className="text-2xl font-bold text-deep-blue mb-4" data-id="element-2034">
                7. Confidentiality & Proprietary Rights
              </h2>

              <h3 className="text-xl font-semibold text-deep-blue mb-3" data-id="element-2035">
                7.1 Confidentiality
              </h3>
              <p className="leading-relaxed mb-6" data-id="element-2036">
                The Client agrees all aspects of HIRE's Proprietary Recruiting
                System are confidential and shall not be disclosed, copied, or
                reverse-engineered.
              </p>

              <h3 className="text-xl font-semibold text-deep-blue mb-3" data-id="element-2037">
                7.2 Data Use
              </h3>
              <p className="leading-relaxed mb-4" data-id="element-2038">
                Applicant data is for the Client's internal use only. HIRE
                reserves the right to use campaign data (including
                non-anonymized data where appropriate) for case studies,
                marketing, and analysis, provided Client business interests are
                not compromised.
              </p>
              <p className="leading-relaxed mb-6" data-id="element-2039">
                HIRE may reference Client's name and logo in general marketing
                materials unless Client objects in writing.
              </p>

              <h3 className="text-xl font-semibold text-deep-blue mb-3" data-id="element-2040">
                7.3 Non-Compete & Non-Circumvention
              </h3>
              <p className="leading-relaxed mb-4" data-id="element-2041">
                The Client shall not, directly or indirectly:
              </p>
              <ul className="list-disc ml-6 space-y-2 mb-4" data-id="element-2042">
                <li data-id="element-2043">
                  Replicate, use, or modify HIRE's recruiting system,
                  advertisements, or proprietary materials outside of this
                  Agreement;
                </li>
                <li data-id="element-2044">
                  Transfer, disclose, or make available HIRE's recruiting
                  system, advertisements, or proprietary materials to any third
                  party, including competitors, agencies, or contractors; or
                </li>
                <li data-id="element-2045">
                  Engage in any conduct that has the purpose or effect of
                  circumventing HIRE's role in providing recruiting services.
                </li>
              </ul>
              <p className="leading-relaxed mb-4" data-id="element-2046">
                This restriction applies for a period of two (2) years, or for
                the full duration that Placement Fees remain payable under
                Section 4.1, whichever is longer, after termination of this
                Agreement.
              </p>
              <p className="leading-relaxed" data-id="element-2047">
                Violations entitle HIRE to seek injunctive relief and liquidated
                damages equal to twelve (12) months of lost value.
              </p>
            </div>

            {/* 8. Term, Renewal, and Termination */}
            <div className="mb-12" data-id="element-2048">
              <h2 className="text-2xl font-bold text-deep-blue mb-4" data-id="element-2049">
                8. Term, Renewal, and Termination
              </h2>

              <h3 className="text-xl font-semibold text-deep-blue mb-3" data-id="element-2050">
                8.1 Term
              </h3>
              <p className="leading-relaxed mb-6" data-id="element-2051">
                This Agreement shall remain in effect for an initial term of 30
                (30) days, beginning on the date of Campaign Launch.
              </p>

              <h3 className="text-xl font-semibold text-deep-blue mb-3" data-id="element-2052">
                8.2 Renewal
              </h3>
              <p className="leading-relaxed mb-6" data-id="element-2053">
                After the initial term, the Agreement renews month-to-month
                unless either party provides at least fourteen (14) days'
                written notice of non-renewal.
              </p>

              <h3 className="text-xl font-semibold text-deep-blue mb-3" data-id="element-2054">
                8.3 Early Termination for Convenience (28-Day Guarantee)
              </h3>
              <p className="leading-relaxed mb-4" data-id="element-2055">
                Notwithstanding any other provision of this Agreement, the
                Client may terminate for convenience at any time within the
                first twenty-eight (28) days following Campaign Launch. In such
                event:
              </p>
              <ul className="list-disc ml-6 space-y-2 mb-4" data-id="element-2056">
                <li data-id="element-2057">
                  HIRE shall refund one hundred percent (100%) of the Build Fee
                </li>
                <li data-id="element-2058">No Placement Fees shall be due.</li>
              </ul>
              <p className="leading-relaxed mb-4" data-id="element-2059">
                Upon such termination, both parties are released from all
                further obligations.
              </p>
              <p className="leading-relaxed mb-4" data-id="element-2060">
                Notwithstanding the foregoing, Client's right to terminate for
                convenience is conditioned upon all undisputed Subscription Fees
                being paid in full and current as of the date notice of
                termination is given.
              </p>
              <p className="leading-relaxed mb-4" data-id="element-2061">
                For the avoidance of doubt, the Client's right to terminate for
                convenience and receive a Build Fee refund is further
                conditioned upon the Client having paid the first Subscription
                Invoice in full, provided that Campaign Launch has occurred. If
                the Client terminates prior to Campaign Launch, the Build Fee is
                non-refundable and the twenty-eight (28) day termination for
                convenience window shall not commence until Campaign Launch.
              </p>
              <p className="leading-relaxed" data-id="element-2062">
                If Client submits a notice of termination while any Subscription
                Fees for the then-current billing period remain unpaid, Client
                will remain responsible for those unpaid Subscription Fees, and
                Client will not be entitled to any refund, credit, or proration
                in connection with such termination.
              </p>
            </div>

            {/* 9. Dispute Resolution & Governing Law */}
            <div className="mb-12" data-id="element-2063">
              <h2 className="text-2xl font-bold text-deep-blue mb-4" data-id="element-2064">
                9. Dispute Resolution & Governing Law
              </h2>
              <p className="leading-relaxed" data-id="element-2065">
                This Agreement shall be governed by Arizona law. Disputes shall
                first be resolved through mediation.
              </p>
            </div>

            {/* 10. Indemnification & Limitation of Liability */}
            <div className="mb-12" data-id="element-2066">
              <h2 className="text-2xl font-bold text-deep-blue mb-4" data-id="element-2067">
                10. Indemnification & Limitation of Liability
              </h2>

              <p className="leading-relaxed mb-6" data-id="element-2068">
                <strong className="text-deep-blue" data-id="element-2069">
                  Indemnification by Client:
                </strong>{' '}
                Client indemnifies HIRE against claims arising from misuse of
                the system, hiring decisions, or breach.
              </p>

              <p className="leading-relaxed mb-6" data-id="element-2070">
                <strong className="text-deep-blue" data-id="element-2071">
                  Indemnification by HIRE:
                </strong>{' '}
                HIRE indemnifies Client against claims resulting from gross
                negligence or intentional misconduct.
              </p>

              <p className="leading-relaxed" data-id="element-2072">
                <strong className="text-deep-blue" data-id="element-2073">
                  Limitation of Liability:
                </strong>{' '}
                HIRE's liability shall not exceed the total fees paid by Client
                in the three months preceding a claim. HIRE shall not be liable
                for indirect or consequential damages.
              </p>
            </div>

            {/* 11. Amendments & Notices */}
            <div className="mb-12" data-id="element-2074">
              <h2 className="text-2xl font-bold text-deep-blue mb-4" data-id="element-2075">
                11. Amendments & Notices
              </h2>
              <p className="leading-relaxed" data-id="element-2076">
                All amendments must be in writing and signed by both parties.
                Notices must be in writing. "Recruiter" and "Corporate
                Recruiter" shall be used interchangeably throughout this
                Agreement and any Services Order executed hereunder. Any
                reference to "Recruiter" in a Services Order shall be deemed to
                refer to the Corporate Recruiter service as defined in Section
                2.
              </p>
            </div>

            {/* 12. Acknowledgment */}
            <div className="mb-12" data-id="element-2077">
              <h2 className="text-2xl font-bold text-deep-blue mb-4" data-id="element-2078">
                12. Acknowledgment and Acceptance
              </h2>
              <p className="leading-relaxed" data-id="element-2079">
                By signing below, both parties acknowledge they have read,
                understood, and agreed to the terms of this Agreement.
              </p>
            </div>

            {/* EXHIBIT A */}
            <div className="mb-12 bg-gray-50 rounded-lg p-6 border-2 border-deep-blue" data-id="element-2080">
              <h2 className="text-2xl font-bold text-deep-blue mb-4" data-id="element-2081">
                EXHIBIT A – TERMINATION & EXIT PROVISIONS
              </h2>

              <h3 className="text-xl font-semibold text-deep-blue mb-3" data-id="element-2082">
                Termination Conditions:
              </h3>
              <ul className="list-disc ml-6 space-y-2 mb-6" data-id="element-2083">
                <li data-id="element-2084">
                  This Agreement shall renew on a month-to-month basis after the
                  initial thirty (30) day term, unless either party provides
                  fourteen (14) days' written notice of non-renewal.
                </li>
                <li data-id="element-2085">
                  The Client may terminate for convenience within the first
                  twenty eight (28) days of execution pursuant to Section 8.3 of
                  this Agreement.
                </li>
                <li data-id="element-2086">
                  HIRE reserves the right to terminate immediately if the Client
                  fails to make payments or breaches confidentiality
                  obligations.
                </li>
              </ul>

              <h3 className="text-xl font-semibold text-deep-blue mb-3" data-id="element-2087">
                Financial Obligations Upon Termination:
              </h3>
              <ul className="list-disc ml-6 space-y-2 mb-6" data-id="element-2088">
                <li data-id="element-2089">
                  The Client remains responsible for all outstanding invoices up
                  to the termination date.
                </li>
                <li data-id="element-2090">
                  Placement Fees and Retention Fees remain payable for all
                  Placements, up to twelve (12) months from the Placement Date.
                </li>
              </ul>

              <h3 className="text-xl font-semibold text-deep-blue mb-3" data-id="element-2091">
                Survival of Obligations:
              </h3>
              <p className="leading-relaxed mb-6" data-id="element-2092">
                Confidentiality, proprietary rights, and all payment obligations
                (including Placement Fees) shall survive termination.
              </p>

              <h3 className="text-xl font-semibold text-deep-blue mb-3" data-id="element-2093">
                Post-Termination Use of Intellectual Property & Data:
              </h3>
              <ul className="list-disc ml-6 space-y-2" data-id="element-2094">
                <li data-id="element-2095">
                  The Client shall cease use of any proprietary materials,
                  recruiting systems, training programs, or strategies developed
                  by HIRE.
                </li>
                <li data-id="element-2096">
                  Any materials provided by HIRE (including advertisements,
                  branding, or process structures) shall not be used to
                  replicate services independently or with a third-party vendor.
                </li>
                <li data-id="element-2097">
                  HIRE retains ownership of all data, processes, and
                  confidential information provided during the term.
                </li>
              </ul>
            </div>

            {/* EXHIBIT B */}
            <div className="mb-12 bg-gray-50 rounded-lg p-6 border-2 border-deep-blue" data-id="element-2098">
              <h2 className="text-2xl font-bold text-deep-blue mb-4" data-id="element-2099">
                EXHIBIT B – INDEMNIFICATION & LIMITATION OF LIABILITY
              </h2>

              <h3 className="text-xl font-semibold text-deep-blue mb-3" data-id="element-2100">
                Indemnification by the Client:
              </h3>
              <p className="leading-relaxed mb-4" data-id="element-2101">
                The Client agrees to indemnify, defend, and hold harmless HIRE
                from any claims, damages, or liabilities arising from the
                Client's misuse of the system, hiring decisions, or breach of
                contract.
              </p>
              <p className="leading-relaxed mb-6" data-id="element-2102">
                The Client assumes full responsibility for compliance with
                employment laws and regulations.
              </p>

              <h3 className="text-xl font-semibold text-deep-blue mb-3" data-id="element-2103">
                Indemnification by HIRE:
              </h3>
              <p className="leading-relaxed mb-4" data-id="element-2104">
                HIRE shall indemnify the Client against claims resulting from
                gross negligence or intentional misconduct in delivering
                services under this Agreement.
              </p>
              <p className="leading-relaxed mb-6" data-id="element-2105">
                HIRE is not responsible for hiring outcomes, employee
                performance, misconduct, retention results, or legal disputes
                related to employment practices.
              </p>

              <h3 className="text-xl font-semibold text-deep-blue mb-3" data-id="element-2106">
                Limitation of Liability:
              </h3>
              <p className="leading-relaxed mb-4" data-id="element-2107">
                In no event shall HIRE's total liability exceed the total fees
                paid by the Client in the three (3) months preceding the claim.
              </p>
              <p className="leading-relaxed mb-6" data-id="element-2108">
                HIRE shall not be liable for indirect, incidental, or
                consequential damages, including loss of profits, business
                interruptions, or reputational harm.
              </p>
              <p className="leading-relaxed mb-6" data-id="element-2109">
                Nothing in this section shall limit the Client's obligation to
                pay Placement Fees or other amounts due under this Agreement.
              </p>

              <h3 className="text-xl font-semibold text-deep-blue mb-3" data-id="element-2110">
                Force Majeure:
              </h3>
              <p className="leading-relaxed" data-id="element-2111">
                Neither party shall be held liable for delays or failures in
                performance due to causes beyond their reasonable control,
                including but not limited to natural disasters, labor strikes,
                government actions, or technological failures. Payment
                obligations incurred prior to the force majeure event shall
                remain enforceable and are not excused.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Footer CTA */}
      <section className="section-padding bg-gray-50" data-id="element-2112">
        <div className="container-custom" data-id="element-2113">
          <div className="max-w-3xl mx-auto text-center" data-id="element-2114">
            <h2 className="mb-6" data-id="element-2115">Questions About This Agreement?</h2>
            <p className="text-body-large mb-8 leading-relaxed" data-id="element-2116">
              We're happy to discuss any questions or concerns you have about
              our service agreement.
            </p>
            <a href="/book-call" className="inline-block bg-mint hover:bg-mint-dark text-deep-blue font-bold px-8 py-4 rounded-lg transition-colors shadow-lg" data-id="element-2117">
              Schedule a Call →
            </a>
          </div>
        </div>
      </section>
    </div>;
}